/**
 * @fileoverview Connect leads, communication review, promotion batches, and assigned attorney reviews through shared Intake navigation. `intakeWorkspaceState.js` owns remembered view paths and `useAssignedAttorneyReviewCount.js` owns badge freshness. Switching a view preserves workspace context without executing a pipeline or changing review assignment.
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AssignedAttorneyReviewCountChip } from './useAssignedAttorneyReviewCount';
import { getIntakeViewPath } from './intakeWorkspaceState';

const VIEWS = [
  { key: 'communications', label: 'Communications' },
  { key: 'batches', label: 'Batches' },
  { key: 'intake', label: 'Leads' },
  { key: 'reviews', label: 'Case Reviews' },
];



export default function IntakeViewSwitch({ activeView, assignedReviewCount = 0 }) {
  const navigate = useNavigate();

  return (
    <div className="intake-view-switch" role="tablist" aria-label="Intake view">
      {VIEWS.map((view) => {
        const active = activeView === view.key;
        return (
          <button
            type="button"
            role="tab"
            aria-selected={active}
            className={`intake-view-switch__item${active ? ' intake-view-switch__item--active' : ''}`}
            key={view.key}
            onClick={active ? undefined : () => navigate(getIntakeViewPath(view.key))}>
            <span>{view.label}</span>
            {view.key === 'reviews' && (
              <AssignedAttorneyReviewCountChip
                count={assignedReviewCount}
                testId="case-reviews-assigned-count" />
            )}
          </button>
        );
      })}
    </div>
  );
}
